import Api from "../utils/axios";

export const NotificationApi = {
    getAllNotification: (payload) => Api.post("/vendor/get-vendor-notification",payload),
    updateAllNotification: () => Api.put("/order/set-all-read-notification"),
    updateNotification: (id,payload) => Api.put(`/order/update-order-notification/${id}`,payload),
}